function getCookie(name: string): string | undefined {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift();
}

function estimateDeviceClass() {
  const isMobile = navigator.userAgent.match(/Mobi/i);
  const deviceMemory = (navigator as any).deviceMemory;
  const memory = (performance as any).memory;
  const ramEstimate =
    deviceMemory && !isMobile
      ? deviceMemory + 'GB'
      : memory && !isMobile
        ? Math.round(memory.jsHeapSizeLimit / 1e9) + 'GB'
        : isMobile
          ? 'Mobile (1-4GB)'
          : 'Desktop (4GB+)';

  return ramEstimate;
}

function getApiUrl(hostname: string): string | null {
  if (hostname.includes('dev.truetale.io'))
    return 'https://api.dev.truetale.io/api/design-store/visitor';

  if (hostname.includes('qa.truetale.io'))
    return 'https://api.qa.truetale.io/api/design-store/visitor';

  const domain = hostname.split('.').slice(-2).join('.');

  const apiDomains: Record<string, string> = {
    'expoprint.io': 'https://api.expoprint.io/api/design-store/visitor',
    'miloprint.com': 'https://api.miloprint.com/api/design-store/visitor',
    'vividtents.com': 'https://api.vividtents.com/api/design-store/visitor',
    'squadmojo.com': 'https://api.squadmojo.com/api/design-store/visitor',
  };

  const apiUrl = apiDomains[domain];
  if (apiUrl) return apiUrl;

  console.error('Unsupported domain:', hostname);
  return null;
}

function getCookieDomain(hostname: string): string {
  if (hostname.includes('dev.truetale.io')) return '.dev.truetale.io';
  if (hostname.includes('qa.truetale.io')) return '.qa.truetale.io';

  const domainParts = hostname.split('.');
  if (domainParts.length >= 2) return `.${domainParts.slice(-2).join('.')}`;

  return hostname;
}

function initializeVisitor(): void {
  const visitorId = getCookie('visitor_id');
  if (visitorId) return;

  const hostname = window.location.hostname;
  const apiUrl = getApiUrl(hostname);
  if (!apiUrl) return;

  const cookieDomain = getCookieDomain(hostname);

  const body = {
    landingUrl: window.location.href,
    referrerUrl: document.referrer || undefined,
    screenResolution: `${window.screen.width}x${window.screen.height}`,
    //Modern browsers (IE9+).
    language: navigator.language,
    //IE11+, Chrome 24+, Firefox 29+, Safari 10+, Edge.
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    // IE9+ (values may be incorrect in older browsers).
    viewportSize: `${window.innerWidth || ''}x${window.innerHeight || ''}`,
    colorDepth: window.screen.colorDepth,
    // Chrome 63+, Edge 79+, Opera 50+.
    deviceMemory: (navigator as any).deviceMemory,
    //Chrome 37+, Firefox 48+, Safari 10.1+, Edge 79+.
    cpuCores: navigator.hardwareConcurrency,
    //ontouchstart: Widely supported; maxTouchPoints: IE10+, modern browsers.
    touchSupport: 'ontouchstart' in window || navigator.maxTouchPoints > 0,
    //Chrome 76+, Firefox 67+, Safari 12.1+, Edge 79+ (falls back to "no-preference").
    prefersColorScheme: window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : window.matchMedia('(prefers-color-scheme: light)').matches
        ? 'light'
        : 'no-preference',
  };

  fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(body),
  })
    .then(async (response: Response) => {
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'API request failed');
      }
      const visitor = await response.text();
      console.log('Visitor created successfully:', visitor);
      return visitor;
    })
    .then((visitorId: string) => {
      const expires = new Date();
      expires.setFullYear(expires.getFullYear() + 1);

      document.cookie = `visitor_id=${visitorId}; expires=${expires.toUTCString()}; domain=${cookieDomain}; path=/; Secure; SameSite=Lax`;
    })
    .catch((error: Error) => {
      console.error('Error creating visitor:', error);
    });
}

// Initialize the visitor check when the script loads
initializeVisitor();
